import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import ExportToExcelCustomButton from "../../components/ExportToExcelButtonCustom";
import ExportToPDFCustomButton from "../../components/ExportPDFfromTable.js";
import CircularProgress from "@mui/material/CircularProgress";
import {DISPLAY_PAGE_SIZE} from "../../constants/constants"
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import "../../css/App.css";
import "../../css/color.css";
import _ from "lodash";
import TokenService from "../../service/TokenService";
import SriyanshCardHeader from "../../components/CardHeader";
import ListDynamicTable from "../../CustomComponant/ListDynamicTable";
import SearchTextField from "../../CustomComponant/SearchTextField";

function PaymentPendingList() {
  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [srcinddata, setSrcinddata] = useState("");

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const [reportData, setReportData] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  // Debounced search function
  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      try {
       // setPageLoader(true);
        const response = await apiClient.post("/paymentpending", {
          uname: uname,
          limit: String(pageSize * (currentPage - 1)),
          offset: String(pageSize),
          srcinddata: searchTerm,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);
        const allDataResponse = await apiClient.post("/paymentpending", {
          uname: uname,
          limit: "0", // No limit
          offset: "0", // No offset
          srcinddata: "", // No search term for fetching all data
        });

        setReportData(allDataResponse.data);
      } catch (error) {
        setReturnData([]);
        setTotalRows(0);
      } finally {
        setPageLoader(false);
      }
    }, 300),
    [uname, currentPage, pageSize]
  );

  useEffect(() => {
    fetchData(srcinddata);
  }, [srcinddata, fetchData]);

  const handleRowClick = (row) => {
    // Handle row click action with the row data
    viewData(row.ponumber, row.billnumber);
   // console.log('Row data:', row);
  };

  const viewData = (po, bill) => {
    navigate("paymententry", {
      state: {
        expponumber: po,
        expbillnumber: bill,
      },
    });
  };

  const columns = [
    "Shop",
    "ponumber",
    "POItemName",
    "billnumber",
    "billdate",
    "crndate",
    "billsenttoaccountdate",
    "daydiff",
  ]; // keys from your data objects
  const columnNames = [
    "Consignee",
    "PO Number",
    "Item Name",
    "Bill Number",
    "Bill Date",
    "CRN Date",
    "Hardcopy Sent to Account Date",
    "Panding Days from Bill Receiving",
  ];

  return (
    <div >
     
      <Card className="Formcard">
      <div className="input-groupHeading">
      Payment Pending

            </div>


        <CardContent>
          {/*-----------------------SEARCH BOX--------------------*/}
          {currentPage === 1 ? (
            <SearchTextField
              label="PO Number"
              value={srcinddata}
              title="Enter PO Number"
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search PO">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}

          {/* ------------------------------LIST of Data ----------------------------*/}

          {pageLoader ? (
            <div className="loaderContainer">
              {" "}
              <CircularProgress />{" "}
            </div>
          ) : (
            <ListDynamicTable
              columns={columns}
              columnNames={columnNames}
              data={returnData}
              totalRows={totalRows}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              onRowClick={handleRowClick}
            />
          )}

          <div className="mb-3 mt-2 container col-12 gap-4 d-flex justify-content-center">
            <ExportToExcelCustomButton
              data={reportData}
              fileName={"Payment Pending"} // PAGE NO. :" + `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to Excel"
            />

            <ExportToPDFCustomButton
              data={reportData}
              fileName={"Payment Pending"} // PAGE NO. :" + `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to PDF"
              pageHeader="Payment Pending List"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default PaymentPendingList;
